import React, { useReducer } from "react";
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Survey from "./pages/Survey";
import { SurveyContextProvider, surveyContextReducer, initalSurveyContextState } from "./context/surveyContext";
import Demographic from "./pages/Demographic";
import Timer from "./components/Timer";
import Disclaimer from "./pages/Disclaimer";
import { LanguageProvider } from "./context/languageContext";
import LanguageSelector from "./components/LanguageSelector";
import Achievements from "./pages/Achievements";
import Results from "./pages/Results/Results";
import MeaningfulWork from "./pages/FiveDomains/MeaningfulWork";
import DomainDeepDive from "./pages/FiveDomains/DomainDeepDive";
import { NotificationProvider } from "./context/notificationContext";
export interface IContextProps {}

const App: React.FC<IContextProps> = (props) => {
  //@ts-ignore
  const [surveyContextState, surveyContextDispatch] = useReducer(surveyContextReducer, initalSurveyContextState);

  const SurveyContextValues = {
    contextState: surveyContextState,
    contextDispatch: surveyContextDispatch,
  };

  return (
    <Router>
      <SurveyContextProvider value={SurveyContextValues}>
        <LanguageProvider>
          <NotificationProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/*" element={<Navigate to={"/"} />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/start" element={<Demographic />} />
              <Route path="/survey/:currentPage" element={<Survey />} />
              <Route path="/results" element={<Results />} />
              <Route path="/domain-deep-dive" element={<DomainDeepDive />} />
              <Route path="/achievements" element={<Achievements />} />
            </Routes>
          </NotificationProvider>
        </LanguageProvider>
      </SurveyContextProvider>
    </Router>
  );
};

export default App;
